/**
 * description: 试用期员工跟踪考核
 * author: bql
 * 2023/7/18 11:14
 */
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";

export class ProbationAssessmentApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'probation-assessment'
    }

    /**
     * 查询考勤情况
     * @param userId
     * @param startTime
     * @param endTime
     */
    public getAssCount(userId,startTime, endTime) {
        return this.send({userId: userId, startDate: startTime, endDate: endTime}, "getCount", this.Methods.GET)
    }

    public sendRegularMessage(formModel2: any) {
        return this.send(formModel2,"sendRegularMessage",this.Methods.POST)
    }
}